import { Utils } from "@/plugin/gis-viewer/Utils";
import { ICircleGeometry, IFindParameter, IOverlayDelete, IOverlayParameter, IPointSymbol, IPointGeometry, IOverlay, IResult } from "@/types/map";
import { loadModules } from "esri-loader";
import HighFeauture2D from "./HighFeauture2D";
import ToolTip from "./ToolTip";
import { CustomLayerFun } from "./lightLine.js";
export class OverlayArcgis2D {
    private static intances: Map<string, any>;
    // private toolTipZoom: any;

    //图层按照type存储
    private overlayGroups: Map<string, __esri.GraphicsLayer> = new Map<string, __esri.GraphicsLayer>(); //覆盖物按照类型分图层
    //地图上overlay的全部图层
    private allOverlayLayers = new Map<string, Map<string, __esri.Graphic>>();
    //地图上所有发光的线
    private overlayGroupsList = new Map();

    //地图上 graphic 的全部图层
    private allGraphicList = new Map<string, __esri.Graphic>();

    private view!: __esri.MapView;
    private primitive2D = ["circle", "cross", "diamond", "square", "triangle", "x"];

    private constructor(view: __esri.MapView) {
        this.view = view;
    }

    public static getInstance(view: __esri.MapView) {
        let id = view.container.id;
        if (!OverlayArcgis2D.intances) {
            OverlayArcgis2D.intances = new Map();
        }
        let intance = OverlayArcgis2D.intances.get(id);
        if (!intance) {
            intance = new OverlayArcgis2D(view);
            OverlayArcgis2D.intances.set(id, intance);
        }
        return intance;
    }

    public static destroy() {
        (OverlayArcgis2D.intances as any) = null;
    }

    // 获取overlay对应的type的图层
    private async getOverlayLayer(type: string, index?: number | undefined) {
        let group = this.overlayGroups.get(type);
        if (!group) {
            group = await this.createOverlayLayer(type, index);
        }
        return group;
    }

    //创建一个type的overlay图层
    private async createOverlayLayer(type: string, index?: number | undefined): Promise<__esri.GraphicsLayer> {
        type MapModules = [typeof import("esri/layers/GraphicsLayer")];
        const [GraphicsLayer] = await (loadModules(["esri/layers/GraphicsLayer"]) as Promise<MapModules>);
        let overlayLayer: __esri.GraphicsLayer = new GraphicsLayer();
        (overlayLayer as any).label = type;
        if (type == "drawOverlays") {
            // this.view.map.add(overlayLayer, 0);//放在底层
            let ix = (this.view as any).mapConfig.operationallayers?.length || 0;
            this.view.map.add(overlayLayer, ix); //放在operationallayers的上层
        } else {
            if (index !== undefined) {
                this.view.map.add(overlayLayer, index);
            } else {
                this.view.map.add(overlayLayer);
            }
        }

        this.overlayGroups.set(type, overlayLayer);
        return overlayLayer;
    }

    private MoveToolTip(type: string, content: string) {
        const view = this.view;
        const moveLayer = this.overlayGroups.get(type);
        let parent = this;
        let tip!: any;
        view.on("pointer-move", function (event) {
            view.hitTest(event).then(response => {
                if (response.results.length > 0) {
                    response.results.forEach(result => {
                        if (result.graphic.layer === moveLayer) {
                            if (!tip) {
                                tip = new ToolTip(
                                    view,
                                    {
                                        title: "",
                                        istip: true,
                                        content: parent.getToolTipContent(result.graphic, content),
                                    },
                                    result.graphic
                                );
                            }
                        }
                    });
                } else {
                    if (tip) {
                        tip.remove();
                        tip = null;
                    }
                }
            });
        });
    }

    private async makeSymbol(symbol: IPointSymbol | undefined): Promise<Object | undefined> {
        if (!symbol || (symbol.type && symbol.type.toLowerCase() == "point-3d")) return undefined;
        let result;

        if (symbol.primitive) {
            if (!this.primitive2D.includes(symbol.primitive)) {
                return undefined;
            }

            result = {
                type: "simple-marker",
                style: symbol.primitive,
                color: symbol.color,
                size: symbol.size,
                xoffset: symbol.xoffset ? symbol.xoffset : null,
                yoffset: symbol.yoffset ? symbol.yoffset : null,
                angle: symbol.rotation ? symbol.rotation : null,
                outline: {
                    color: symbol.outline?.color,
                    width: symbol.outline?.size,
                },
            };
        } else if (symbol.url) {
            result = {
                type: "picture-marker",
                url: symbol.url,
                width: symbol.width ? symbol.width : symbol.size instanceof Array ? symbol.size[0] : 30,
                height: symbol.height ? symbol.height : symbol.size instanceof Array ? symbol.size[1] : 30,
                xoffset: symbol.xoffset ? symbol.xoffset : null,
                yoffset: symbol.yoffset ? symbol.yoffset : null,
                angle: symbol.rotation ? symbol.rotation : null,
            };
        } else if (symbol.type == "arrow") {
            let lineColor = symbol.color ? await this.getColor(symbol.color) : [0, 100, 0, 255];
            let arrowColor = symbol.arrow && symbol.arrow.color ? await this.getColor(symbol.arrow.color) : [255, 255, 255, 255];
            let lineSize: number = (symbol.width || symbol.size || 6) as number;
            let arrowSize = (symbol.arrow && symbol.arrow.size) || lineSize - 1;
            lineSize = Math.max(lineSize, arrowSize); //取线和箭头的最大值
            result = {
                type: "cim",
                data: {
                    type: "CIMSymbolReference",
                    symbol: {
                        type: "CIMLineSymbol",
                        symbolLayers: [
                            {
                                type: "CIMVectorMarker",
                                enable: true,
                                size: arrowSize,
                                markerPlacement: {
                                    type: "CIMMarkerPlacementAlongLineSameSize",
                                    endings: "Custom",
                                    placementTemplate: [(symbol.arrow && symbol.arrow.space) || 14],
                                    offsetAlongLine: 2,
                                },
                                frame: {
                                    xmin: -lineSize,
                                    ymin: -lineSize,
                                    xmax: lineSize,
                                    ymax: lineSize,
                                },
                                markerGraphics: [
                                    {
                                        type: "CIMMarkerGraphic",
                                        geometry: {
                                            paths: [
                                                [
                                                    [-lineSize - 2, lineSize - 1],
                                                    [0, 0],
                                                    [-lineSize - 2, -lineSize + 1],
                                                ],
                                            ],
                                        },
                                        symbol: {
                                            type: "CIMLineSymbol",
                                            symbolLayers: [
                                                {
                                                    type: "CIMSolidStroke",
                                                    enable: true,
                                                    color: arrowColor,
                                                    width: (symbol.arrow && symbol.arrow.width) || 2,
                                                },
                                            ],
                                        },
                                    },
                                ],
                            },
                            {
                                type: "CIMSolidStroke",
                                enable: true,
                                width: symbol.width || symbol.size || 6,
                                color: lineColor,
                            },
                        ],
                    },
                },
            };
        } else if (symbol.type == "line" || symbol.type == "polyline" || symbol.type == "simple-line") {
            result = {
                type: "simple-line", // autocasts as new SimpleLineSymbol()
                color: (symbol as any).color || "red",
                width: (symbol as any).width || 1,
                style: (symbol as any).style || "solid",
            };
        } else if (symbol.type == "fill" || symbol.type == "polygon" || symbol.type == "simple-fill") {
            result = {
                type: "simple-fill", // autocasts as new SimpleFillSymbol()
                color: (symbol as any).color || "rgba(255,0,0,0.5)",
                style: (symbol as any).style || "solid",
                outline: {
                    // autocasts as new SimpleLineSymbol()
                    style: (symbol as any).outline ? (symbol as any).outline.style || "solid" : "solid",
                    color: (symbol as any).outline ? (symbol as any).outline.color || "green" : "green",
                    width: (symbol as any).outline ? (symbol as any).outline.width || 0.4 : 0.4,
                },
            };
        } else if (symbol.type == "point") {
            result = {
                type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
                style: "circle",
                color: "red",
                size: 0, // pixels
                outline: {
                    // autocasts as new SimpleLineSymbol()
                    color: [255, 255, 0, 0],
                    width: 0, // points
                },
            };
        } else if (symbol.type == "text") {
            result = symbol;
        } else {
            result = {
                type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
                style: "circle",
                color: "black",
                size: 8, // pixels
                outline: {
                    // autocasts as new SimpleLineSymbol()
                    color: [255, 255, 0, 0],
                    width: 0, // points
                },
            };
        }

        return result;
    }

    private async getColor(c: Array<number> | string): Promise<Array<number>> {
        const [Color] = await loadModules(["esri/Color"]);
        let nc = new Color(c);
        return [nc.r, nc.g, nc.b, (nc.a * 255) % 256];
    }

    /**根据graphic的属性生成弹出框*/
    private getInfoWindowContent(graphic: any): any {
        let content = "";
        //键值对
        for (let fieldName in graphic.attributes) {
            if (graphic.attributes.hasOwnProperty(fieldName)) {
                content += "<b>" + fieldName + ": </b>" + graphic.attributes[fieldName] + "<br>";
            }
        }
        //去掉最后的<br>
        content = content.substring(0, content.lastIndexOf("<br>"));
        if (graphic.buttons !== undefined) {
            content += "<hr>";
            graphic.buttons.forEach((buttonConfig: { type: string; label: string }) => {
                content += "<button type='button' class='btn btn-primary btn-sm' onclick='mapFeatureClicked(" + '"' + buttonConfig.type + '", "' + graphic.id + '"' + ")'>" + buttonConfig.label + "</button>  ";
            });
        }
        let divContent = document.createElement("div");
        divContent.innerHTML = content;
        return divContent;
    }
    //使popup中的content,支持html.
    private getPopUpHtml(graphic: any, content: string): any {
        let tipContent = content;
        for (let fieldName in graphic.attributes) {
            if (graphic.attributes.hasOwnProperty(fieldName)) {
                tipContent = tipContent.replace("{" + fieldName + "}", graphic.attributes[fieldName]);
            }
        }
        let divContent = document.createElement("div");
        divContent.innerHTML = tipContent;
        return divContent;
    }
    //使toolTip中支持{字段}的形式
    private getToolTipContent(graphic: any, content: string): string {
        let tipContent = content;
        if (content) {
            //键值对
            for (let fieldName in graphic.attributes) {
                if (graphic.attributes.hasOwnProperty(fieldName)) {
                    tipContent = tipContent.replaceAll("{" + fieldName + "}", graphic.attributes[fieldName]);
                }
            }
        } else {
            tipContent = this.getInfoWindowContent(graphic).innerHTML;
        }
        return tipContent;
    }
    public async addOverlaysLine(params: IOverlayParameter): Promise<IResult> {
        const layerType = params.type || "default";
        // const overlayLayer = (await this.getOverlayLayer(params.type || "default", params.layerIndex)) as __esri.GraphicsLayer;

        const [Graphic, Circle, geometryJsonUtils, PopupTemplate, SpatialReference, WebMercatorUtils, geometryEngine] = await loadModules(["esri/Graphic", "esri/geometry/Circle", "esri/geometry/support/jsonUtils", "esri/PopupTemplate", "esri/geometry/SpatialReference", "esri/geometry/support/webMercatorUtils", "esri/geometry/geometryEngine"]);
        const toolTipZoom = params.toolTipZoom || 0;
        const showPopup = params.showPopup;
        const defaultInfoTemplate = params.defaultInfoTemplate;
        const autoPopup = params.autoPopup;
        const defaultButtons = params.defaultButtons;
        const defaultVisible = params.defaultVisible !== false;
        const custom = params.custom;
        const iswgs = params.iswgs !== false;
        const dataList = params.dataList || [];
        const zooms = params.defaultZooms || [0, 0];
        const showRegion = params.showRegion === true;
        // if (params.defaultZooms) {
        //     overlayLayer.minScale = Utils.getScale(this.view, zooms[0]);
        //     overlayLayer.maxScale = Utils.getScale(this.view, zooms[1]);
        // }

        const showToolTip = params.showToolTip;
        const toolTipContent = params.toolTipContent;

        if (showToolTip && toolTipContent) {
            this.MoveToolTip(layerType, toolTipContent);
        }

        let addCount = 0;
        let drawRegion: Array<__esri.Geometry> | undefined = undefined;
        if (showRegion) {
            drawRegion = await this.getDrawOverlays();
        }
        console.log(dataList, 112);
        let timer: number;
        if (toolTipZoom) {
            this.view.watch("zoom", async (newValue, oldValue) => {
                console.log("当前层级参考", newValue);
                if (newValue < toolTipZoom) {
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        this.allGraphicList.forEach((item: any) => {
                            item?.tooltip.hide();
                        });
                    }, 500);
                } else {
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        this.allGraphicList.forEach((item: any) => {
                            item?.tooltip.show();
                        });
                    }, 500);
                }
            });
        }
        const [BaseLayerViewGL2D, reactiveUtils, GraphicsLayer, webMercatorUtils] = await loadModules(["esri/views/2d/layers/BaseLayerViewGL2D", "esri/core/reactiveUtils", "esri/layers/GraphicsLayer", "esri/geometry/support/webMercatorUtils"]);

        let CustomLayer = await CustomLayerFun(reactiveUtils, webMercatorUtils, GraphicsLayer, BaseLayerViewGL2D);
        const graphics = params.overlays.map((overlay: any) => {
            console.log(overlay, "数据");

            const fields = overlay.fields || {};
            fields.type = params.type;
            fields.id = overlay.id;
            return {
                attributes: {
                    color: [2, 203, 110],
                },
                geometry: webMercatorUtils.geographicToWebMercator({
                    paths: [overlay.geometry.paths[0]],
                    type: "polyline",
                }),
            };
        });

        const layer = new CustomLayer({
            graphics: graphics,
        });
        // overlayLayer.add(layer);
        this.overlayGroupsList.set(`${params.type}Line` || "default", layer);
        this.view.map.layers.add(layer);
        // setTimeout(() => {
        //     this.view.map.remove(layer);
        // }, 10000);
        return {
            status: 0,
            message: "ok",
            result: `成功添加${params.overlays.length}中的个覆盖物`,
        };
    }

    // 添加覆盖物
    public async addOverlays(params: IOverlayParameter): Promise<IResult> {
        const layerType = params.type || "default";
        const overlayLayer = (await this.getOverlayLayer(params.type || "default", params.layerIndex)) as __esri.GraphicsLayer;

        const [Graphic, Circle, geometryJsonUtils, PopupTemplate, SpatialReference, WebMercatorUtils, geometryEngine] = await loadModules(["esri/Graphic", "esri/geometry/Circle", "esri/geometry/support/jsonUtils", "esri/PopupTemplate", "esri/geometry/SpatialReference", "esri/geometry/support/webMercatorUtils", "esri/geometry/geometryEngine"]);
        const toolTipZoom = params.toolTipZoom || 0;
        const defaultSymbol = await this.makeSymbol(params.defaultSymbol);
        const showPopup = params.showPopup;
        const defaultInfoTemplate = params.defaultInfoTemplate;
        const autoPopup = params.autoPopup;
        const defaultButtons = params.defaultButtons;
        const defaultVisible = params.defaultVisible !== false;
        const custom = params.custom;
        const iswgs = params.iswgs !== false;
        const dataList = params.dataList || [];
        const zooms = params.defaultZooms || [0, 0];
        const showRegion = params.showRegion === true;
        if (params.defaultZooms) {
            overlayLayer.minScale = Utils.getScale(this.view, zooms[0]);
            overlayLayer.maxScale = Utils.getScale(this.view, zooms[1]);
        }

        const showToolTip = params.showToolTip;
        const toolTipContent = params.toolTipContent;

        if (showToolTip && toolTipContent) {
            this.MoveToolTip(layerType, toolTipContent);
        }

        let addCount = 0;
        let drawRegion: Array<__esri.Geometry> | undefined = undefined;
        if (showRegion) {
            drawRegion = await this.getDrawOverlays();
        }
        console.log(dataList, 112);
        let timer: number;
        if (toolTipZoom) {
            this.view.watch("zoom", async (newValue, oldValue) => {
                console.log("当前层级参考", newValue);
                if (newValue < toolTipZoom) {
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        this.allGraphicList.forEach((item: any) => {
                            item?.tooltip.hide();
                        });
                    }, 500);
                } else {
                    clearTimeout(timer);
                    timer = setTimeout(() => {
                        this.allGraphicList.forEach((item: any) => {
                            item?.tooltip.show();
                        });
                    }, 500);
                }
            });
        }
        for (let i = 0; i < params.overlays.length; i++) {
            const overlay = params.overlays[i];
            if ((overlay.geometry as any).x) {
                (overlay.geometry as any).x = Number((overlay.geometry as any).x);
                (overlay.geometry as any).y = Number((overlay.geometry as any).y);
            }
            if (!iswgs) {
                (overlay.geometry as any).spatialReference = this.view.spatialReference;
            }
            //如果存在城建坐标,使用坐标替换
            if (!this.view.spatialReference.isWGS84 && !this.view.spatialReference.isWebMercator) {
                if ((overlay.geometry as any).x_cj) {
                    (overlay.geometry as any).x = Number((overlay.geometry as any).x_cj);
                    (overlay.geometry as any).y = Number((overlay.geometry as any).y_cj);
                }
                (overlay.geometry as any).spatialReference = this.view.spatialReference;
            }
            let geometry: any;
            if ("center" in overlay.geometry && "radius" in overlay.geometry) {
                geometry = new Circle({
                    center: (overlay.geometry as ICircleGeometry).center,
                    radius: (overlay.geometry as ICircleGeometry).radius,
                    radiusUnit: "meters",
                });
            } else {
                geometry = geometryJsonUtils.fromJSON(overlay.geometry);
            }

            if (overlay.symbol && !overlay.symbol.type) {
                overlay.symbol.type = geometry.type;
            }
            let overlaySymbol = await this.makeSymbol(overlay.symbol);
            //TODO: 加入更详细的参数是否合法判断
            if (!defaultSymbol && !overlaySymbol) {
                continue;
            }
            const fields = overlay.fields || {};
            fields.type = params.type;
            fields.id = overlay.id;
            const buttons = overlay.buttons;

            let graphic = new Graphic({
                geometry,
                symbol: overlaySymbol || defaultSymbol,
                attributes: fields || {},
            });
            graphic.type = params.type;
            graphic.id = overlay.id;
            graphic.buttons = buttons || defaultButtons;
            if (showPopup) {
                if (defaultInfoTemplate === undefined) {
                    graphic.popupTemplate = new PopupTemplate({
                        content: this.getInfoWindowContent(graphic),
                    });
                } else {
                    graphic.popupTemplate = {
                        title: defaultInfoTemplate.title,
                        content: this.getPopUpHtml(graphic, defaultInfoTemplate.content),
                    };
                }
                if (autoPopup) {
                    this.view.popup.open({
                        title: "",
                        content: this.getInfoWindowContent(graphic),
                        location: geometry,
                    });
                    this.view.popup.dockOptions = {
                        buttonEnabled: false,
                        breakpoint: { width: 400, height: 30 },
                    };
                }
            }
            if (custom) {
                let customContent = custom.content;
                let customtool = new ToolTip(
                    this.view,
                    {
                        title: "",
                        id: overlay.id,
                        zooms: custom.zooms,
                        visible: (!custom.visible && defaultVisible) || false,
                        content: this.getToolTipContent(graphic, customContent),
                        anchor: custom.anchor,
                    },
                    graphic
                );
                graphic.tooltip = customtool;
                this.allGraphicList.set(graphic.id, graphic);
            }
            if (graphic.attributes.toolTipStatus) {
                graphic.tooltip.hide();
            }

            //添加覆盖物之前删除同名覆盖物(type+id)
            let overlays = this.allOverlayLayers.get(params.type || "default");
            if (overlays == undefined) {
                overlays = new Map<string, __esri.Graphic>();
            }
            const oly_key = JSON.stringify({ id: graphic.id, type: graphic.type });
            const overlay_tmp = overlays?.get(oly_key); //同名覆盖物

            //区域参数
            if (showRegion && drawRegion !== undefined) {
                let newArr = drawRegion.filter((geo: __esri.Geometry) => {
                    return geometryEngine.contains(geo, geometry);
                });
                if (newArr.length > 0) {
                    if (overlay_tmp) {
                        overlayLayer.remove(overlay_tmp);
                    }
                    overlays.set(oly_key, graphic);
                    this.allOverlayLayers.set(params.type || "default", overlays);
                    overlayLayer.add(graphic);
                }
            } else {
                if (overlay_tmp) {
                    overlayLayer.remove(overlay_tmp);
                }
                overlays.set(oly_key, graphic);
                this.allOverlayLayers.set(params.type || "default", overlays);
                overlayLayer.add(graphic);
            }
            overlayLayer.visible = defaultVisible;
            addCount++;
        }
        return {
            status: 0,
            message: "ok",
            result: `成功添加${params.overlays.length}中的${addCount}个覆盖物`,
        };
    }

    public async showToolTip(params: IOverlayDelete) {
        let id = params.id || "";
        let ids = params.ids || [];
        if (id) {
            let graphic: any = this.allGraphicList.get(id);
            graphic?.tooltip.show();
        }
        ids.forEach(id => {
            let graphic: any = this.allGraphicList.get(id);
            graphic?.tooltip.show();
        });
    }

    public async hideToolTip(params: IOverlayDelete) {
        let id = params.id || "";
        let ids = params.ids || [];
        if (id) {
            let graphic: any = this.allGraphicList.get(id);
            graphic?.tooltip.hide();
        }
        ids.forEach(id => {
            let graphic: any = this.allGraphicList.get(id);
            graphic?.tooltip.hide();
        });
    }

    public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
        const [geometryJsonUtils, geometryEngine] = await loadModules(["esri/geometry/support/jsonUtils", "esri/geometry/geometryEngine"]);

        const iswgs = params.iswgs !== false;

        let addCount = 0;
        let regionOverlays = [];
        let drawRegion: Array<__esri.Geometry> | undefined = undefined;
        drawRegion = await this.getDrawOverlays();
        for (let i = 0; i < params.overlays.length; i++) {
            const overlay = params.overlays[i];
            if ((overlay.geometry as any).x) {
                (overlay.geometry as any).x = Number((overlay.geometry as any).x);
                (overlay.geometry as any).y = Number((overlay.geometry as any).y);
            }
            if (!iswgs) {
                (overlay.geometry as any).spatialReference = this.view.spatialReference;
            }
            let geometry = geometryJsonUtils.fromJSON(overlay.geometry);
            if (overlay.symbol && !overlay.symbol.type) {
                overlay.symbol.type = geometry.type;
            }

            if (drawRegion !== undefined) {
                let newArr = drawRegion.filter((geo: __esri.Geometry) => {
                    return geometryEngine.contains(geo, geometry);
                });
                if (newArr.length > 0) {
                    regionOverlays.push(overlay);
                }
            } else {
                regionOverlays.push(overlay);
            }
        }
        params.overlays = regionOverlays;
        let result = params;
        return {
            status: 0,
            message: "ok",
            result: result,
        };
    }

    public async getOverlays(params: IOverlayDelete): Promise<IResult> {
        let types: any;
        if (params === null || params === undefined) {
            types = [];
        } else {
            types = params.types || [];
        }
        let groups: Array<any> = [];
        let layers = this.view.map.allLayers.toArray().filter((baselayer: any) => {
            if (baselayer.type == "graphics" && (types.length == 0 || types.indexOf(baselayer.label) > -1)) {
                return true;
            }
            return false;
        });
        const mapview = this.view;
        layers.forEach((overlay: any) => {
            if (overlay.label !== undefined && overlay.label !== "drawOverlays") {
                if (overlay.clusterAreaDisplay) {
                    let clusterRes = overlay.data.map((obj: any) => {
                        return { attributes: obj, geometry: { x: obj.x, y: obj.y } };
                    });
                    groups.push({ overlays: clusterRes, type: overlay.label });
                } else {
                    let result = overlay.graphics.map((graphic: any) => {
                        return {
                            uniData: {
                                screenpoint: mapview.toScreen(graphic.geometry), // 屏幕坐标
                                ...graphic.attributes,
                            },
                            geometry: graphic.geometry,
                        };
                    });
                    result.forEach((item: any) => {
                        groups.push(item);
                    });
                }
            }
        });

        return {
            status: 0,
            message: "ok",
            result: { overlays: groups },
        };
    }

    public async getDrawOverlays(): Promise<Array<__esri.Geometry> | undefined> {
        let unionGeo: Array<__esri.Geometry> | undefined = undefined;
        const [geometryEngine, Graphic, WebMercatorUtils] = await loadModules(["esri/geometry/geometryEngine", "esri/Graphic", "esri/geometry/support/webMercatorUtils"]);
        let geometrys: any[] = [];
        let layer = this.view.map.allLayers.find((baselayer: any) => {
            return baselayer.type == "graphics" && baselayer.label === "drawOverlays";
        });
        if (layer) {
            (layer as __esri.GraphicsLayer).graphics.forEach((graphic: __esri.Graphic) => {
                let geo = graphic.geometry.spatialReference.isWebMercator ? WebMercatorUtils.webMercatorToGeographic(graphic.geometry) : graphic.geometry;
                geometrys.push(geo);
            });
            unionGeo = geometrys;
            //unionGeo = await geometryEngine.union(geometrys);
        }

        return unionGeo;
    }
    public async deleteOverlaysLine(params: IOverlayDelete): Promise<IResult> {
        // console.log("[debug][gisviewer-vue] deleteOverlays", params);
        let types = params.types || [];
        let delcount = 0;
        // let groups: Array<__esri.GraphicsLayer> = [];  //迷惑行为？？
        if (types.length > 0) {
            types.forEach(item => {
                delcount++;
                let layers = this.overlayGroupsList.get(`${item}Line`);
                this.view.map.remove(layers);
            });
        }
        return {
            status: 0,
            message: "ok",
            result: `成功删除${delcount}个覆盖物`,
        };
    }
    // 删除指定overlays
    public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
        // console.log("[debug][gisviewer-vue] deleteOverlays", params);
        let types = params.types || [];
        let ids = params.ids || [];
        let delcount = 0;
        let tpIds: string[] = [];
        // let groups: Array<__esri.GraphicsLayer> = [];  //迷惑行为？？
        this.overlayGroups.forEach((overlayLayer, key) => {
            if (types.length == 0 || types.indexOf(key) > -1) {
                // groups.push(overlayLayer);
                for (let i = 0; i < overlayLayer.graphics.length; i++) {
                    let graphic: any = overlayLayer.graphics.getItemAt(i);
                    if (
                        //只判断type
                        (types.length > 0 && ids.length === 0 && types.indexOf(graphic.type) >= 0) ||
                        //只判断id
                        (types.length === 0 && ids.length > 0 && ids.indexOf(graphic.id) >= 0) ||
                        //type和id都要判断
                        (types.length > 0 && ids.length > 0 && types.indexOf(graphic.type) >= 0 && ids.indexOf(graphic.id) >= 0)
                    ) {
                        if (graphic.tooltip) {
                            graphic.tooltip.remove();
                        }
                        overlayLayer.remove(graphic);

                        // 更新overlaysOfLayers
                        let overlays = this.allOverlayLayers.get(key);
                        if (overlays) {
                            const oly_key = JSON.stringify({
                                id: graphic.id,
                                type: graphic.type,
                            });
                            overlays.delete(oly_key);
                            this.allOverlayLayers.set(key, overlays);
                        }

                        delcount++;
                        i--;
                    }
                }
            }
            // 对于没有overlays的图层则将该图层从地图上移除;  @notice 如果没有这步操作则可能触发arcgis 的bug
            if (overlayLayer.graphics.length == 0) {
                this.view.map.remove(overlayLayer);
                this.overlayGroups.delete(key);
            }
        });
        // groups.forEach((overlayLayer: __esri.GraphicsLayer) => {

        // }, this);

        return {
            status: 0,
            message: "ok",
            result: `成功删除${delcount}个覆盖物`,
        };
    }

    // 删除所有overlays
    public async deleteAllOverlays(): Promise<IResult> {
        // console.log("[debug][gisviewer-vue] deleteAllOverlays");
        // console.log(this.view.map.allLayers);
        // console.log(this.view);
        this.overlayGroups.forEach((layer, key) => {
            layer.removeAll();
            this.view.map.remove(layer);
        });
        this.overlayGroups.clear();
        this.allOverlayLayers.clear();
        this.allGraphicList.clear();
        ToolTip.clear(this.view);
        //
        return {
            status: 0,
            message: "ok",
        };
    }

    public async findFeature(params: IFindParameter): Promise<IResult> {
        let type = params.layerName;
        let overlayLayer = this.overlayGroups.get(type);
        if (!overlayLayer) {
            return {
                status: 0,
                message: "ok",
            };
        }
        let ids = params.ids || [];
        let level = params.level || this.view.zoom;
        let overlays = overlayLayer.graphics;
        let centerResult = params.centerResult !== false;
        overlays.forEach((overlay: any) => {
            if (type == overlay.type && ids.indexOf(overlay.id) >= 0) {
                if (centerResult) {
                    this.view.goTo({ target: overlay.geometry, zoom: level });
                }
                this.startJumpPoint([overlay]);
            }
        });
        return {
            status: 0,
            message: "ok",
        };
    }

    private async startJumpPoint(graphics: any[]) {
        let high = HighFeauture2D.getInstance(this.view);
        high.startup(graphics);
    }
}
